export enum GradientButtonType {
    BluePurple = "blue-purple",
    PurpleBlue = "purple-blue",
    OrangePink = "orange-pink",
    Purple = "purple"
  }